import { VisiblePrescriptionStatus as VisiblePrescriptionStatusKind } from "common/types/prescriptions";

import Status from "client/common/components/content/Status";

import { getColorForPrescriptionStatus, getLabelForPrescriptionStatus } from "../utils";

type PrescriptionStatusProps = {
  prescription: { visible_status: VisiblePrescriptionStatusKind };
};

const PrescriptionStatus = ({ prescription }: PrescriptionStatusProps) => {
  return (
    <Status color={getColorForPrescriptionStatus(prescription.visible_status)}>
      {getLabelForPrescriptionStatus(prescription.visible_status)}
    </Status>
  );
};

export default PrescriptionStatus;
